import React, { createContext, useState, useContext } from "react";

const BannerContext = createContext();

export const useBanner = () => useContext(BannerContext);

export const BannerProvider = ({ children }) => {
  const [banner, setBanner] = useState(null);

  const showBanner = (message, type = "info", timeout = 5000) => {
    setBanner({ message, type });
    if (timeout > 0) {
      setTimeout(() => setBanner(null), timeout);
    }
  };

  return (
    <BannerContext.Provider value={{ banner, showBanner }}>
      {children}
    </BannerContext.Provider>
  );
};
